<template>
  <!-- Card 17trt6jd8uu, etapa 4: selos na página inicial e no Pitch Coins.
       Mostra todos; os ainda não conquistados ficam transparentes e o
       andamento incentiva a conquistar. -->
  <section
    v-if="badges.length"
    class="bgc"
    :style="{ borderColor: color }"
    :aria-label="$t('pitchCoins.badgesTitle')"
  >
    <header class="bgc__head">
      <v-icon size="22" :color="color">mdi-seal-variant</v-icon>
      <div>
        <h2 class="bgc__title">{{ $t("pitchCoins.badgesTitle") }}</h2>
        <p class="bgc__sub">{{ $t(subtitleKey) }}</p>
      </div>
      <v-btn
        v-if="moreTo"
        :to="moreTo"
        small
        outlined
        rounded
        :color="color"
        class="bgc__more"
      >
        {{ $t("pitchCoins.badgesMore") }}
      </v-btn>
    </header>

    <ul class="bgc__grid">
      <li v-for="badge in badges" :key="badge.code" class="bgc__item">
        <badge-icon :badge="badge" :size="48" />
        <div class="bgc__text">
          <span class="bgc__name">{{ nameOf(badge) }}</span>
          <span v-if="badge.count > 0" class="bgc__state">
            {{ $tc("pitchCoins.badgesEarned", badge.count) }}
          </span>
          <span v-else-if="badge.manual" class="bgc__state bgc__state--muted">
            {{ $t("pitchCoins.badgesManual") }}
          </span>
          <span v-else class="bgc__state bgc__state--muted">
            {{ $t("pitchCoins.badgesProgress", progressOf(badge)) }}
          </span>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import pitchCustomerApi from "@/shared/pitchCustomerApi";
import pitchPartnerApi from "@/shared/pitchPartnerApi";
import { classThemes } from "@/shared/classThemes";
import BadgeIcon from "@/components/coins/BadgeIcon.vue";

// Falha de rede esconde o cartão, nunca a página.
export default {
  name: "BadgesCard",

  components: { BadgeIcon },

  props: {
    profile: {
      type: String,
      default: "customer",
      validator: (value) => ["customer", "partner"].includes(value),
    },
    subtitleKey: { type: String, default: "pitchCoins.badgesSub" },
    // Com destino, mostra o botão "Saiba mais" no cabeçalho.
    moreTo: { type: String, default: "" },
  },

  data() {
    return { badges: [] };
  },

  computed: {
    api() {
      return this.profile === "partner" ? pitchPartnerApi : pitchCustomerApi;
    },
    color() {
      return classThemes[this.profile]?.primary || "#A826E1";
    },
  },

  async mounted() {
    try {
      const res = await this.api.getCoinBadges();
      this.badges = res?.data?.data || [];
    } catch (error) {
      this.badges = [];
    }
  },

  methods: {
    nameOf(badge) {
      const key = `pitchCoins.badges.${badge.code}.name`;
      return this.$te(key) ? this.$t(key) : badge.name;
    },

    progressOf(badge) {
      return { done: badge.progress, total: badge.target };
    },
  },
};
</script>

<style scoped>
.bgc {
  margin-bottom: 20px;
  padding: 18px 20px;
  border: 2px solid;
  border-radius: 16px;
  background: var(--dk-surface, #fff);
}

.bgc__head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 14px;
}

.bgc__more {
  margin-left: auto;
  flex-shrink: 0;
  text-transform: none;
}

.bgc__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--dk-ink, #2b2540);
}

.bgc__sub {
  margin: 2px 0 0;
  font-size: 0.8rem;
  color: var(--dk-muted, #6b6580);
}

.bgc__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.bgc__item {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.bgc__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.bgc__name {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--dk-ink, #2b2540);
  overflow-wrap: anywhere;
}

.bgc__state {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--dk-ember-deep, #8a6500);
}

.bgc__state--muted {
  font-weight: 400;
  color: var(--dk-muted, #6b6580);
}
</style>
